import { operatorColors } from '~/utils/operatorColors';
import { CustomInputDrop } from '~/utils/CustomInputDrop';
import { CustomHandle } from '~/utils/CustomHandle';

// Node de comparação "Diferente de"
// Este componente representa um nó de comparação que verifica se dois valores são diferentes
export const OperatorNotEqualNode = ({ data, notNode = false, onDataChange }) => {
    // Funções para lidar com a mudança dos drops de entrada
    const handleLeftChange = (newDrop) => onDataChange({ leftDrop: newDrop, rightDrop: data.rightDrop });
    const handleRightChange = (newDrop) => onDataChange({ leftDrop: data.leftDrop, rightDrop: newDrop });
    return (
        <div className="node-operator-notequal" style={{ 
            display: 'flex', 
            flexDirection: (data?.layout || 'vertical') === 'vertical' ? 'column' : 'row',
            alignItems: 'center', 
            justifyContent: 'center',
            gap: '8px',
            width: '100%'
        }}>
            <CustomInputDrop dropData={data.leftDrop || { id: 'left', type: null, data: {} }} dropId="left" onDropChange={handleLeftChange} />
            <div style={{
                background: operatorColors['Diferente de'] || '#ff9800',
                color: 'white',
                borderRadius: '8px',
                padding: '8px 12px',
                fontWeight: 'bold',
                fontSize: '16px',
                minWidth: '40px',
                textAlign: 'center',
                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                ≠
            </div>
            <CustomInputDrop dropData={data.rightDrop || { id: 'right', type: null, data: {} }} dropId="right" onDropChange={handleRightChange} />
            {!notNode && <CustomHandle type="target" position="top" connectionCount={1} />}
            {!notNode && <CustomHandle type="source" position="bottom" connectionCount={1} />}
        </div>
    );
};